import type { EventContentArg } from '@fullcalendar/core'

import { formatCrossDayRange, isCrossDay } from './cross-day-label'

const formatTime = (d: Date) => `${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')}`

/** 日をまたぐ予定は分割後の区切り (0:00) ではなく本来の開始・終了時刻を出す */
const buildTimeText = (arg: EventContentArg) => {
  const { start, end, allDay } = arg.event
  if (allDay || !start || !end || !arg.timeText || !isCrossDay(start, end)) return arg.timeText
  const range = formatCrossDayRange(start, end, arg.isEnd && !arg.isStart ? end : start, formatTime)
  return `${range.start} - ${range.end}`
}

/** FullCalendar のデフォルト描画と同じ構造で時刻表記だけ差し替える */
export const CalendarEventContent = ({ arg }: { arg: EventContentArg }) => {
  const timeText = buildTimeText(arg)
  return (
    <div className="fc-event-main-frame">
      {timeText && <div className="fc-event-time">{timeText}</div>}
      <div className="fc-event-title-container">
        <div className="fc-event-title fc-sticky">{arg.event.title || '\u00A0'}</div>
      </div>
    </div>
  )
}
